import { Bug } from "lucide-react";
import "./style.css"

interface Props{
    icon?: any
    text: any
}
export function IconLateralContent({icon, text} : Props){
    return (
        <div className="" style={{ display: "flex", alignItems: "center", flexDirection: "column", opacity: .7, marginTop: 20 }}>
            <div>
                {icon ? icon : <Bug size={40}/>}
            </div>
            <div className="user-select-none" style={{ marginTop: 10 }}>
                <p>{text}</p>
            </div>
        </div>
    );
}